import { render, staticRenderFns } from "./ActiveStudentsDialog.vue?vue&type=template&id=2e605c56&scoped=true"
import script from "./ActiveStudentsDialog.vue?vue&type=script&lang=js"
export * from "./ActiveStudentsDialog.vue?vue&type=script&lang=js"
import style0 from "./ActiveStudentsDialog.vue?vue&type=style&index=0&id=2e605c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e605c56",
  null
  
)

export default component.exports